module.exports = __webpack_public_path__ + "static/media/ser_tag_on_tag_off.2bf0cc1b.png";